const GRANT_PER_SOCKET_OLD = 300;
const GRANT_PER_SOCKET_NEW = 500;
const GRANT_PER_SOCKET_2020 = 350;
const GRANT_PER_SOCKET_2026 = 500;
const SCHEME_CHANGE_DATE = new Date('2018-07-10T00:00:00Z');
const GRANT_CHANGE_2020 = new Date('2020-04-01T00:00:00Z');
const GRANT_CHANGE_2026 = new Date('2026-04-01T00:00:00Z'); // EPB-13707.

const redemptions_ready = function() {

  calcGrantTotals();

  $(document).on('change keyup', `input[id$='modelNumber'],
                            input[id$='serialNumber'],
                            input[id$='dataCommsSignalBoost'],
                            input[id$='dataCommsEnabled_true'],
                            input[id$='dataCommsEnabled_false'],
                            input[id$='numberOfSockets_1'],
                            input[id$='numberOfSockets_2'],
                            input[id$='numberOfSockets_3'],
                            input[id$='numberOfSockets_4'],
                            input[id='workplace_redemption_totalInstallationCost_to_pounds'],
                            input[id$='installationDate']`, function(event) {
    calcGrantTotals(event);
  });

  $(document).on('click', '[data-form-delete=".chargepoint-row"]', function(event) {
    calcGrantTotals(event);
  });

  function calcGrantTotals (_) {
    let socketsInstalledBefore2026SchemeChange = 0;
    let socketsInstalledAfter2026SchemeChange = 0;
    const createdAt = new Date($('#workplace_redemption_applicationCreated').val());

    $(".chargepoint-row").each(function() {
      let valueSet = [
          $(this).find("input[id$='modelNumber']").val().length > 0,
          $(this).find("input[id$='serialNumber']").val().length > 0,
          $(this).find("input[id$='dataCommsSignalBoost']").val().length > 0,
          $(this).find("input[id$='dataCommsEnabled_true']").is(':checked'),
          $(this).find("input[id$='dataCommsEnabled_false']").is(':checked'),
          $(this).find("input[id$='installationDate']").val().length > 0
      ].some((set) => !!set);

      if (!valueSet) {
          return;
      }

      const installationDate = Date.parse($(this).find("input[id$='installationDate']").val());
      const installedBeforeApril1st2026 = installationDate < GRANT_CHANGE_2026;
      let inc = 0;
      if ($(this).find("input[id$='numberOfSockets_1']").is(':checked')) {
        inc = 1;
      } else if ($(this).find("input[id$='numberOfSockets_2']").is(':checked')) {
        inc = 2;
      } else if ($(this).find("input[id$='numberOfSockets_3']").is(':checked')) {
        inc = 3;
      } else if ($(this).find("input[id$='numberOfSockets_4']").is(':checked')) {
        inc = 4;
      }
      if (installedBeforeApril1st2026) {
        socketsInstalledBefore2026SchemeChange += inc;
      } else {
        socketsInstalledAfter2026SchemeChange += inc;
      }
    })
    const totalNumSockets = socketsInstalledBefore2026SchemeChange + socketsInstalledAfter2026SchemeChange;

    const inputInstallationCost = Number.parseInt($('#workplace_redemption_totalInstallationCost_to_pounds').val(), 10) || 0;
    const totalInstallationCost = createdAt < SCHEME_CHANGE_DATE
          ? Number.MAX_SAFE_INTEGER
          : 0.75 * inputInstallationCost;

    // Calculate grant values
    let preApril2026GrantPerSocket;
    if (createdAt < SCHEME_CHANGE_DATE) {
    	preApril2026GrantPerSocket = GRANT_PER_SOCKET_OLD;
    } else if (createdAt < GRANT_CHANGE_2020) {
    	preApril2026GrantPerSocket = GRANT_PER_SOCKET_NEW;
    } else {
    	preApril2026GrantPerSocket = GRANT_PER_SOCKET_2020;
    }
    
    const grantValueSocksInstalledBeforeApril2026 = socketsInstalledBefore2026SchemeChange * preApril2026GrantPerSocket;
    const grantValueSocksInstalledAfterApril2026 = socketsInstalledAfter2026SchemeChange * GRANT_PER_SOCKET_2026;
    const grantValue = grantValueSocksInstalledBeforeApril2026 + grantValueSocksInstalledAfterApril2026

    const finalGrantValue = Math.min(totalInstallationCost, grantValue).toFixed(2);
    const costLessGrant = totalInstallationCost === 0 ? 0 : (inputInstallationCost - finalGrantValue).toFixed(2);

    // Update the values in the financials section
    let socketText = "sockets";
    if (totalNumSockets === 1) socketText = "socket";

    $('#socket-count').text(totalNumSockets + ' ' + socketText);
    $('#grant-value').text("£" + finalGrantValue);
    $('#costLessGrant-value').text("£" + costLessGrant);

    // and update the (hidden) form value value that refreshes the model
    $('#workplace_redemption_grantAmount').val(Number.parseFloat(finalGrantValue));
  }
}

$(document).ready(redemptions_ready);
